import type { NavigateOptions } from "react-router-dom";
import type { PushActionCategory, PushActionConfig } from "./types";

/*
-- Push Actions --
Push action are used to add action buttons to a notifications.
unfortunately, apple restricts us to "register" possible actions on app's launch and so we cannot fully customize the actions in "run time".

The actions are split into 2 parts:
1. the actions them-selves - an actions holds an actionId (retrieved by the client to determine the action pressed by the user)
  and it hold the text that is displayed in the notification's button

2. action category - the action category is an array of actions that are displayed together.
  for example: if I have 2 actions (accept and decline) then the actions category can look like: 
    {
      id: "PROMPT",
      buttons: ["DECLINE", "ACCEPT"]
    }
  And when we attach the notification with the actions category "PROMPT" then these 2 buttons will show

NOTE - a single action can be in multiple categories
*/

/**
 * The possible push action ids
 */
export enum PushActions {
  NAVIGATE = "navigate",
  CANCEL = "cancel",
}

/**
 * The possible push actions category ids
 */
export enum PushActionCategories {
  TO_DETAILS = "to_details",
}

/**
 * The type to determine the type of the "extra" assigned with the notification
 */
declare abstract class _PushActionExtraMap implements Record<PushActions, any> {
  [PushActions.NAVIGATE]: {
    to: string;
    options?: NavigateOptions;
  };
  [PushActions.CANCEL]: undefined;
}

export type PushActionExtraMap = _PushActionExtraMap;

export const PUSH_ACTIONS: PushActionConfig[] = [
  {
    id: PushActions.NAVIGATE,
    text: "לפרטים",
  },
  {
    id: PushActions.CANCEL,
    text: "ביטול",
  },
];

export const PUSH_ACTION_CATEGORIES: PushActionCategory[] = [
  {
    id: PushActionCategories.TO_DETAILS,
    buttons: [PushActions.NAVIGATE],
  },
];
